import { KoncentroBaseModel } from './koncentro-base.model';

export class Currency extends KoncentroBaseModel {
  public dto = 'CurrencyDto';

  public id?: number;
  public iso_code: string;
  public name?: string;
  public simbol?: string;
  public decimal: number;
}



// WEBPACK FOOTER //
// ./src/app/models/currencies.model.ts